module.exports = __webpack_public_path__ + "static/media/elshadai.a32b8385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/elshadai.jpg
// module id = 236
// module chunks = 0